import { Allergen, DietType } from 'lib/home/generated/types/api';

export const primaryDietsLabelMap = {
  [DietType.Vegan]: 'Vegan',
  [DietType.Vegetarian]: 'Vegetarian',
  [DietType.Pescatarian]: 'Pescatarian',
  [DietType.NoRedMeat]: 'No Red Meat',
  [DietType.Flexitarian]: 'I Like It All'
};

const secondaryOptionsLabelMap = {
  [DietType.DairyFree]: 'Dairy Free',
  [DietType.LowCarb]: 'Low Carb',
  [DietType.GlutenFree]: 'Gluten Free',
  [DietType.NonSpicy]: 'Non-Spicy'
};

const allergenLabelMap = {
  [Allergen.TreeNuts]: 'Tree Nuts'
};

export const primaryDiets = Object.entries(DietType)
  .filter(([key, value]) => primaryDietsLabelMap[value])
  .map(([key, value]) => ({ label: primaryDietsLabelMap[value] || key, value }));

export const secondaryOptions = Object.entries(DietType)
  .filter(([key, value]) => secondaryOptionsLabelMap[value])
  .map(([key, value]) => ({
    label: secondaryOptionsLabelMap[value] || key,
    value
  }));

export const allergens = Object.entries(Allergen).map(([key, value]) => ({
  label: allergenLabelMap[value] || key,
  value
}));

export const buildPreferencesFromValues = ({ primaryDiet, secondaryOptions, allergens }) => ({
  allergens: Object.entries(allergens).reduce(
    (prev, [allergen, value]) => (value ? [...prev, allergen] : [...prev]),
    []
  ),
  diets: [
    primaryDiet,
    ...Object.entries(secondaryOptions).reduce((prev, [option, value]) => (value ? [...prev, option] : [...prev]), [])
  ]
});

export const mealPreferencesIconMap = {
  [Allergen.Milk]: 'dairy',
  [Allergen.Eggs]: 'egg',
  [Allergen.Peanuts]: 'peanuts',
  [Allergen.Shellfish]: 'shellfish',
  [Allergen.Soybean]: 'soybean',
  [Allergen.TreeNuts]: 'treeNuts',
  [Allergen.Fish]: 'pescatarian',
  [Allergen.Wheat]: 'wheat',
  [DietType.DairyFree]: 'dairyFree',
  [DietType.GlutenFree]: 'glutenFree',
  [DietType.LowCarb]: 'lowCarb',
  [DietType.NonSpicy]: 'nonSpicy',
  [DietType.NoRedMeat]: 'noRedMeat',
  [DietType.Pescatarian]: 'pescatarian',
  [DietType.Vegan]: 'vegan',
  [DietType.Vegetarian]: 'vegetarian',
  [DietType.Flexitarian]: 'heart'
};
